import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { usePortalTarget } from '../../components/UIProvider/b06a6d7d3063091eeee24790f7ab6da8c2d138992e1cbad0f6fb0cbc953133e9.cfe-internal.js';

var Portal = function Portal(_ref) {
  var children = _ref.children,
    portalTarget = _ref.portalTarget;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    container = _useState2[0],
    setContainer = _useState2[1];
  var globalPortalTarget = usePortalTarget();
  useEffect(function () {
    var element = document.createElement('div');
    var target = portalTarget || globalPortalTarget || document.body;
    target.appendChild(element);
    setContainer(element);
    return function () {
      target.removeChild(element);
    };
  }, [portalTarget, globalPortalTarget]);

  // only render children once parent has been appended to DOM
  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
};

export { Portal as default };
